import { styled } from '@mui/material';
import * as Common from '../../components/Styles/Common.styles';

export const Root = styled(Common.Root)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;
